import React from 'react';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

const defaultProps = {
  data: [],
  columns: [],
};

function ClientFunnelTable({ data, columns, }) {
  return (
    <MaterialTable
      title={null}
      columns={columns}
      options={{
        search: false,
        pageSize: 10
      }}
      data={data}
    />
  );
}

ClientFunnelTable.propTypes = propTypes;
ClientFunnelTable.defaultProps = defaultProps;
export default ClientFunnelTable;



// WEBPACK FOOTER //
// ./src/components/ClientFunnelTable/index.jsx